/** Whether the current platform is macOS. */
const isMac = (): boolean => {
  return (
    navigator.platform.toUpperCase().includes('MAC')
    || navigator.userAgent.toUpperCase().includes('MAC')
  );
};

/** `⌘` on macOS, `Ctrl` on other platforms. */
export const modifierKey = (isMac()) ? '⌘' : 'Ctrl';
